import { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Typography, Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import { useAppStore } from "../appStore";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export default function AddForm({ closeEvent }) {
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const baseURL = process.env.REACT_APP_API_URL;
    const updateChakraCategories = useAppStore((state) => state.updateChakraCategories);
    const token = useAppStore((state) => state.token);

    const createUser = async () => {
        let posturl = baseURL + "chakra";

        await axios
            .post(
                posturl,
                {
                    name: name,
                    description: description,
                },
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        "Content-type": "Application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then(function (res) {
                console.log(res.data);
                getUsers();
                closeEvent();
                Swal.fire(
                    "Submitted!",
                    "Your file has been submitted.",
                    "success"
                );
            })
            .catch(function (error) {
                console.log("kcheckpost" + error); //return 429
            });
    };

    const getUsers = async () => {
        let posturl = baseURL + "chakra";
        await axios
            .get(posturl, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-type": "Application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((res) => {
                updateChakraCategories(res.data);
                console.log(res.data);
            })
            .catch((err) => {
                console.log("kcheckpost" + err); //return 429
            });
    };

    const handleNameChange = (event) => {
        setName(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    };

    return (
        <>
            <Box sx={{ m: 2 }} />
            <Typography variant="h5" align="center">
                Add Chakra
            </Typography>
            <IconButton
                style={{ position: "absolute", top: "0", right: "0" }}
                onClick={closeEvent}
            >
                <CloseIcon />
            </IconButton>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        error={false}
                        id="name"
                        name="name"
                        value={name}
                        onChange={handleNameChange}
                        label="Name"
                        size="small"
                        sx={{ marginTop: "30px", minWidth: "100%" }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormControl
                        variant="outlined"
                        size="small"
                        sx={{
                            minWidth: "100%",
                        }}
                    >
                        <InputLabel id="label-qualification">Type</InputLabel>
                        <Select
                            labelId="label-qualification"
                            value={description}
                            onChange={handleDescriptionChange}
                            onBlur={handleDescriptionChange}
                            label="Description"
                        >
                            <MenuItem value={"Chakra"}>Chakra</MenuItem>
                            <MenuItem value={"Major"}>Major</MenuItem>
                            <MenuItem value={"Minor"}>Minor</MenuItem>
                            <MenuItem value={"Organ"}>Organ</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h5" align="center">
                        <Button variant="contained" onClick={createUser}>
                            Submit
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        </>
    );
}
